export const BookingStatusIdEnum = {
	BOOKED: 1,
	COMPLETE: 2,
	CANCELLED: 3,
	WAITINGFORPAYMENT: 4,
	CANCELLEDWITHFEE: 5
};
